
import { useTranslate } from 'src/locales';
import { MeetingStatus } from 'src/services/meetings/meetings.types';

import Label from 'src/components/label';

export function MeetingStatusLabel({ status }: { status: MeetingStatus }) {

  const { t } = useTranslate();

  const getStatusColor = (): 'success' | 'warning' | 'error' | 'info' => {
    switch (status) {
      case MeetingStatus.SCHEDULED:
        return 'info';
      case MeetingStatus.IN_PROGRESS:
        return 'warning';
      case MeetingStatus.COMPLETED:
        return 'success';
      case MeetingStatus.CANCELLED:
        return 'error';
      default:
        return 'info';
    }
  };

  const getStatusLabel = (): string => {
    switch (status) {
      case MeetingStatus.SCHEDULED:
        return t('enums.meeting_status.scheduled');
      case MeetingStatus.IN_PROGRESS:
        return t('enums.meeting_status.in_progress');
      case MeetingStatus.COMPLETED:
        return t('enums.meeting_status.completed');
      case MeetingStatus.CANCELLED:
        return t('enums.meeting_status.cancelled');
      default:
        return status;
    }
  };

  return (
    <Label
      variant="soft"
      color={getStatusColor()}
      sx={{ alignSelf: 'flex-start' }}
    >
      {getStatusLabel()}
    </Label>
  )
}
